import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Checkout } from "./Checkout";

const stripePromise = loadStripe(
  process.env.REACT_APP_ENV === "production"
    ? "pk_live_Gq5azMUpxnzAiRUEzk7lQsCz000crfRftf"
    : "pk_test_6NQsDFKMnhHwvdBlvDCnJnio00qH3BKYRK"
);

export default function CheckoutWrapper() {
  return (
    <Elements stripe={stripePromise}>
      <Checkout />
    </Elements>
  );
}
